function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#178443"
    },
    d: "M256,229.517c29.272,0,52.966-23.693,52.966-52.966C279.693,176.552,256,200.245,256,229.517"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDD7AD"
    },
    d: "M505.819,345.741c6.833-5.667,8.227-15.713,3.045-22.934c-11.052-15.404-20.224-19.059-58.659,1.148 l-76.579,46.804c-23.393,12.438-84.789,8.828-111.289,8.828c0,0,62.517,4.228,37.579-32.997 c-12.412-18.529-33.81-28.796-56.117-28.796h-34.428c-20.065,0-39.874-6.215-55.896-18.291 c-37.394-28.204-109.338,27.118-109.338,27.118v158.897h123.586c17.629,0,35.231-1.324,52.665-3.981l115.059-17.496 c3.928,0,7.742-0.459,11.432-1.28l0.185-0.026c9.304-1.315,17.814-6.029,24.611-12.526L505.819,345.741z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4482C3"
    },
    points: "0,512 44.138,512 44.138,300.138 0,300.138  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M152.56,414.897c-4.882,0-8.828-3.946-8.828-8.828c0-22.113,16.499-35.31,44.138-35.31h85.786 c4.882,0,8.828,3.946,8.828,8.828c0,4.882-3.946,8.828-8.828,8.828H187.87c-26.483,0-26.483,13.286-26.483,17.655 C161.388,410.951,157.442,414.897,152.56,414.897"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#24AE5F"
    },
    d: "M256,264.828c-4.882,0-8.828-3.946-8.828-8.828v-97.103c0-4.882,3.946-8.828,8.828-8.828 s8.828,3.946,8.828,8.828V256C264.828,260.882,260.882,264.828,256,264.828"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#805333"
    },
    d: "M150.673,297.853c1.916-0.159,3.761,0.309,5.526,1.651c16.022,12.076,35.831,18.291,55.896,18.291 h31.709h2.719c22.307,0,43.705,10.267,56.117,28.796c18.891,28.204-12.403,32.609-28.69,33.095 c8.448,0.124,18.759,0.371,29.643,0.38c26.368-0.044,55.517-1.58,70.038-9.304l76.579-46.804c1.43-0.75,2.728-1.404,4.087-2.083 l-10.196-30.561c0,0-19.862-15.448-26.483-17.655c-6.621-2.207-59.586-2.207-70.621,0c-11.034,2.207-34.207-32-44.138-26.483 s-75.034,16.552-79.448,17.655c-4.414,1.103-99.822,26.483-99.822,26.483l-0.221,0.433 C133.229,291.136,142.613,292.822,150.673,297.853"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13A085"
    },
    d: "M335.448,79.448c0,43.882-35.566,79.448-79.448,79.448s-79.448-35.566-79.448-79.448 S212.118,0,256,0S335.448,35.566,335.448,79.448"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,123.586c-15.837,0-26.483-10.646-26.483-26.483c0-4.882,3.946-8.828,8.828-8.828 c4.882,0,8.828,3.946,8.828,8.828c0,6.1,2.728,8.828,8.828,8.828c3.249,0,6.329-1.43,8.43-3.911c0.75-0.892,0.83-1.907,0.75-2.595 c-0.124-1.139-0.706-2.198-1.615-2.895l-25.971-20.215c-4.679-3.646-7.724-9.119-8.333-15.016 c-0.609-5.8,1.103-11.423,4.829-15.819c5.464-6.462,13.453-10.169,21.91-10.169c15.837,0,26.483,10.646,26.483,26.483 c0,4.882-3.946,8.828-8.828,8.828s-8.828-3.946-8.828-8.828c0-6.1-2.728-8.828-8.828-8.828c-3.249,0-6.329,1.43-8.43,3.911 c-0.75,0.892-0.83,1.898-0.75,2.586c0.124,1.148,0.706,2.207,1.624,2.913l25.962,20.206c4.67,3.637,7.715,9.101,8.333,14.998 c0.618,5.809-1.103,11.432-4.829,15.837C272.446,119.879,264.457,123.586,256,123.586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancing);
export default __webpack_public_path__ + "static/media/financing.40bb7ccd6ae40c29d7f10d92ae7b2aef.svg";
export { ForwardRef as ReactComponent };